/* eslint-disable eqeqeq */
import React from 'react';
import { AppsType, getIsIosApp, getMoneyType, getSmoozieMultiplier, Pages } from '../custom_views/insta_custom_views/utils_android/UtilsAndroid';

const ActiveTaskItem = ({ task, onTaskClicked, backView, isUpmob, isActive }) => {
    const isIos = getIsIosApp()
    const openTask = () => {
        onTaskClicked(task, ( task.garanted_review_enable == 1 ? isIos ? Pages.task_ios : Pages.task_garanted_review : Pages.task), backView);
    };
    // console.log("active task props.task = ", task)
    return (
        <div>
            {task.dateTitle && <p style={{ marginLeft: '16px' }} className="task_name">{task.dateTitle}</p>}
            <div className="task_item_container hover" onClick={openTask}>
                <div className="flex task_item_full_width">
                    <img className="task_item_icon custom_icons_task_shadow" src={task.icon} alt="" />
                    <div className="block justify_content task_item_full_width">
                        <p className="task_item_title task_name_overflow">{task.name}</p>
                        {isActive ?
                        task.type_os != undefined ?
                        <p className="task_item_type">{task.type_os == AppsType.android ? "Задание в Google Play"  : "Задание в RuStore"}</p>
                        :
                        <p style={{color : '#2DB789'}} className="task_item_type">Активно</p>
                        : 
                        <p style={{color : '#2DB789'}} className="task_item_type">Выполнено</p>}
                        {/* <p className='task_item_price'>+{task.price_one_install_employer}₽</p> */}
                    </div>
                </div>
                {/* <p className="task_item_money_c">+{task.price_one_install_employer}₽</p> */}
                {/* {!isUpmob ?  */}
                    <div className="task_item_money_c flex">+{task.price_one_install_employer * getSmoozieMultiplier()}<span>{getMoneyType(isUpmob)}</span></div>
                {/* :
                    <p className="task_item_money_c">+{task.price_one_install_employer}₽</p>
                } */}
            </div>
       
        </div>
    );
};

export default ActiveTaskItem;